import { apiClient } from './apiClient';

const API_V1 = '/api/v1';

export type AdminUserRecord = {
  id: string;
  firstName: string | null;
  lastName: string | null;
  primaryEmail: string | null;
  isAdmin: boolean;
  salesforceId: string | null;
  salesforceUsername: string | null;
  salesforceProfileId: string | null;
  createdAt: number;
  lastSignInAt: number | null;
  imageUrl: string;
};

export type SalesforceUserResult = {
  salesforceId: string;
  salesforceUsername: string;
  salesforceProfileId: string;
  firstName: string | null;
  lastName: string | null;
};

export const adminService = {
  listUsers(token: string): Promise<AdminUserRecord[]> {
    return apiClient.getJson<AdminUserRecord[]>(`${API_V1}/admin/users`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },

  lookupSalesforceUser(token: string, emailPrefix: string): Promise<SalesforceUserResult> {
    return apiClient.postJson<SalesforceUserResult>(
      `${API_V1}/admin/users/lookup-salesforce`,
      { emailPrefix },
      { headers: { Authorization: `Bearer ${token}` } },
    );
  },

  createUser(
    token: string,
    payload: {
      emailPrefix: string;
      isAdmin: boolean;
      salesforceId: string;
      salesforceUsername: string;
      salesforceProfileId: string;
      firstName: string | null;
      lastName: string | null;
    },
  ): Promise<AdminUserRecord> {
    return apiClient.postJson<AdminUserRecord>(`${API_V1}/admin/users`, payload, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
};
